import { Button, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { GridRowId } from '@material-ui/data-grid';
import { CustomRadio } from '../../../../lib/CustomRadio';
import { connect, useDispatch } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import {
    DIVIDEND_MATCHED_UNMATCHED_DATA_TYPE,
    fundsByLienFlag,
    getDividendFilteredData,
    getErrorMessage,
    notLockedFolio,
    portfoliosByClosingBalance,
    portfoliosByDividend,
    portfoliosByIdcwStatus,
    portfoliosByModeOfHolding,
    portfoliosByPayout,
    portfoliosByReinvestment,
    portfoliosByTransactionResource,
} from '../../portfolios/utils';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import { sendPhoneOTP } from '../../../../redux-store/actions/nct';
import { IsAllow, SCHEMES_RESPONSE } from '../../../../redux-store/types/portfolio';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import NoFoliosFound from '../NoFoliosFound';
import { OTP_ACTIONS, EQUITY, LIQUID, DEBT, OTHER, IDCW_OPTION } from '../../../../utils/constants';
import { getMatchAndUnMatchedFunds, maskMobileNumber } from '../../../../utils/utilityFunctions';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { ActionHeader, FaqLink } from '../index';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';

const PAYOUT_TO_REINVEST = 'payout-to-reinvest';
const REINVEST_TO_PAYOUT = 'reinvest-to-payout';
export interface DividendTableRowType extends SCHEMES_RESPONSE {
    id?: GridRowId;
    isDisabled?: boolean;
}

const { dashboard } = en;

const MenuList = [
    {
        label: dashboard.ChangeDividend.payoutToReinvest,
        value: PAYOUT_TO_REINVEST,
    },
    {
        label: dashboard.ChangeDividend.reinvestToPayout,
        value: REINVEST_TO_PAYOUT,
    },
];

const columns: TableColumn[] = [
    { field: 'folio', headerName: 'Folio', width: 150 },
    {
        field: 'id',
        headerName: 'Scheme Name',
        valueGetter: ({ row }) => `${row?.amcName}-${row?.schemeName}`,
        width: 350,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    { field: 'investorName', headerName: 'Primary Holder', width: 200 },
    {
        field: 'mobile',
        headerName: 'Mobile Number',
        width: 220,
        valueGetter: ({ row }) => maskMobileNumber(row?.mobile),
    },
    {
        isFilter: true,
        field: 'assetType',
        headerName: 'Category',
        filterBy: true,
        renderStaticFilters: [EQUITY, LIQUID, DEBT, OTHER],
    },
];

function ChangeDividend(props: any) {
    const [rowData, setRowData] = useState<DividendTableRowType[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { portfolios = {} } = props;
    const { data: folioList = [] } = portfolios;
    const [dividendOption, setDividendOption] = useState<string | null>(null);

    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<DividendTableRowType[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns,
        loading,
    });

    useEffect(() => {
        setLoading(true);
        async function fetchPortfolio() {
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            try {
                await props.getPortfolio({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                });
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        fetchPortfolio();
    }, []);

    useEffect(() => {
        resetTable();
        resetFilters();
    }, [dividendOption]);

    useEffect(() => {
        const filterBySchemeOption: Function[] = [
            dividendOption === PAYOUT_TO_REINVEST ? portfoliosByPayout : portfoliosByReinvestment,
        ];
        const dividendFilters: Function[] = [
            notLockedFolio,
            portfoliosByModeOfHolding,
            portfoliosByTransactionResource,
            // portfoliosByClosingBalance,
            portfoliosByDividend,
            portfoliosByIdcwStatus,
            fundsByLienFlag,
        ];

        const schemeOptionsData = getDividendFilteredData(folioList, filterBySchemeOption);
        const data = getMatchAndUnMatchedFunds(dividendFilters, schemeOptionsData, true);
        setRowData(data);
    }, [props.portfolios, dividendOption]);

    const handleSubmit = async () => {
        try {
            const { pan = '', pekrn = '', mobile = '' } = props;
            let res = await props.sendPhoneOTP({
                mobile: mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.changeDividend,
            });
            props.history.push('change-dividend-otp', {
                mobile: mobile,
                pan: pan,
                foliosToUpdate: selectedRows,
                dividend: dividendOption,
                currentIdcwOption: dividendOption === PAYOUT_TO_REINVEST ? 'D' : 'R',
                newIdcwOption: dividendOption === PAYOUT_TO_REINVEST ? 'R' : 'D',
                ...(res || {}).body,
                success: true,
            });
        } catch (err: any) {
            alert(err.message);
        }
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    }

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                foliosArray={selectedRows}
                callBackFn={handleSubmit}
                trxnType={NFT_TRXN_TYPE_MAP.changeOfIdcw}
                triggerCheck={callPanSeed}
                goBack={false}
                resetTrigger={resetTrigger}
            />
            <ActionHeader header={dashboard.ChangeDividend.ChangeDividendHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <CustomRadio
                        extraClass="custom-radio desktop_mode"
                        title={dashboard.ChangeDividend.radioHeading}
                        name="select-dividend"
                        list={MenuList}
                        selectedValue={dividendOption}
                        handleRadioChange={(value: string) => setDividendOption(value)}
                    />
                    <FormControl variant="filled" className="mobile_mode">
                        <InputLabel id="change-dividend-option-label">
                            {dashboard.ChangeDividend.radioHeading}
                        </InputLabel>
                        <Select
                            labelId="change-dividend-option-label"
                            id="change-dividend-option"
                            value={dividendOption}
                            onChange={(e: any) => setDividendOption(e.target.value)}
                        >
                            {MenuList.map((item) => (
                                <MenuItem key={item.label} value={item.value}>
                                    {item.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {!!dividendOption && (
                        <>
                            <h5> {dashboard.ChangeDividend.ChangeDividendInfo}</h5>
                            {!!loading || tableRows.length ? (
                                <TableWithCollapse
                                    rows={tableRows}
                                    columns={tableColumns}
                                    isRowSelectable={(params) =>
                                        params.row.isDisabled ? false : true
                                    }
                                    selectedRows={selectedRows}
                                    setSelectedRows={setSelectedRows}
                                    toolTipTextGetter={({ row }) =>
                                        getErrorMessage(row, [notLockedFolio, fundsByLienFlag])
                                    }
                                    toolTipEnabled
                                    checkBoxEnabled
                                    resetFilters={resetFilters}
                                    {...filters}
                                />
                            ) : (
                                <NoFoliosFound info={'No Folios Found'} />
                            )}
                            <FaqLink section={IDCW_OPTION} history={props.history} />
                        </>
                    )}
                </div>

                {!!dividendOption && (
                    <div className="curved-bg-content-inner-bottom">
                        {!!rowData.length && (
                            <div className="table-submit">
                                <Button
                                    className="customBtn"
                                    disabled={!selectedRows.length}
                                    onClick={() => setCallPanSeed(true)}
                                >
                                    {dashboard.ChangeDividend.buttonText}
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, sendPhoneOTP },
)(ChangeDividend);
